import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

// Handles the URL fragment #session_id=... returned by Emergent Auth.
// Exchanges with backend and redirects to the dashboard.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const data = await api.exchangeGoogle(sessionId);
        // Clear the hash and reload at clean root so AppContext picks up the new cookie
        window.location.replace(window.location.origin + '/');
      } catch (e) {
        console.error('Auth callback failed', e);
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F6F6F4] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-heading font-semibold text-[15px] mb-2">Signing you in…</div>
        <div className="text-[12px] text-[#787872] font-mono">Establishing session</div>
      </div>
    </div>
  );
}
